import { useUpgrade } from './useUpgrade'
import { sendNotify } from '~/api'
import { ORDER_BEHAVIOR, ORDER_TYPE, RIGHTS_FEATURE } from '~/api/interface'
import { PageKey } from '~/constants/page'
import { useAddStorage } from '~/features/paymentDesk'

export enum ACTION_MAP {
  UPGRADE,
  BUY,
  CONTACT,
}

type StorageSpace = {
  type: number
}

// 发送站内通知
const handleSendNotification = async () => {
  const { $t } = useNuxtApp()
  try {
    const response: any = await sendNotify()
    if (!response.error_code) {
      message.success($t('yi-tong-zhi-gei-guan-li-yuan'))
    }
  } catch (error) {
    console.error(error)
  }
}

export const useStorageSpace = (options: StorageSpace) => {
  const { $t } = useNuxtApp()
  const userInfo: any = useUserInfo()

  if (options.type === ACTION_MAP.UPGRADE) {
    if (isGlobalVersion()) {
      return navigateTo({ name: PageKey.SUBSCRIBE })
    }
    useUpgrade()
  } else if (options.type === ACTION_MAP.BUY) {
    useAddStorage({
      title: $t('jia-gou-cun-chu-kong-jian'),
      user_info: userInfo.value,
      behavior: ORDER_BEHAVIOR.ADD_PURCHASE,
      feature_type: RIGHTS_FEATURE.storage,
      order_type: ORDER_TYPE.STORAGE,
    })
  } else {
    handleSendNotification()
  }
}
